var EnumEditingMode;
(function (EnumEditingMode) {
    EnumEditingMode["inline"] = "inline";
    EnumEditingMode["bubble"] = "bubble";
})(EnumEditingMode || (EnumEditingMode = {}));
export { EnumEditingMode };
